import { VueHammer } from 'vue2-hammer';
import Vue from 'vue';


VueHammer.config.press = {
    time: 700,
};

Vue.use(VueHammer);
